import { Header, Subheader, HeaderContainer, PrimaryButton } from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import I18n from "../../../translations/i18n";

type PasswordProps = {
  onClose: () => void;
  email: string;
}

const EnrollmentConfirmationScreen = ({ onClose, email }: PasswordProps) => {
  return (
    <>
      <HeaderContainer>
        <Header>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.enrollment_confirmation.header`)}</Header>
        <Subheader>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.enrollment_confirmation.subheader`, {email_address: email})}</Subheader>
      </HeaderContainer>
      <PrimaryButton onClick={onClose}>Continue Booking</PrimaryButton>
      <TermsPrivacy/>
    </>
  );
}

export default EnrollmentConfirmationScreen;